const GetTrueShow = (a = [])=>{
    let returnShow = true;

    a.forEach((d,n)=>{
            if(d[0] != d[1]){
                returnShow = false;
            }
        }
    );


    return returnShow;
}
export default GetTrueShow